import type { LucideIcon } from "lucide-react";
import {
  BookOpen,
  Car,
  FileUp,
  LayoutDashboard,
  Percent,
  Receipt,
  ScrollText,
  Settings,
  Shield,
  ShieldCheck,
  TrendingUp,
  Trophy,
  Users,
} from "lucide-react";
import { createElement } from "react";
import { PERMISSIONS } from "@/auth/permissions";
import type { NavigationConfig } from "@/types/navigation";

function icon(Icon: LucideIcon) {
  return createElement(Icon, {
    size: 18,
    strokeWidth: 1.75,
    "aria-hidden": true,
  });
}

export const navigationConfig: NavigationConfig = {
  main: [
    {
      id: "dashboard",
      kind: "link",
      label: "Pulpit",
      icon: icon(LayoutDashboard),
      href: "/",
      exact: true,
    },
    {
      id: "clients",
      kind: "link",
      label: "Klienci i RODO",
      icon: icon(ShieldCheck),
      href: "/clients",
      permission: PERMISSIONS.CLIENTS.READ,
    },
    {
      id: "results",
      kind: "link",
      label: "Wyniki firmy",
      icon: icon(TrendingUp),
      href: "/results",
      permission: PERMISSIONS.REPORTS.READ,
      section: "Finanse",
    },
    {
      id: "settlements",
      kind: "link",
      label: "Rozliczenia",
      icon: icon(Receipt),
      href: "/settlements",
      permission: PERMISSIONS.SETTLEMENTS.READ,
      section: "Finanse",
    },
    {
      id: "import",
      kind: "link",
      label: "Import danych",
      icon: icon(FileUp),
      href: "/import",
      permission: PERMISSIONS.SETTLEMENTS.CREATE,
      section: "Finanse",
    },
    {
      id: "agents",
      kind: "link",
      label: "Agenci",
      icon: icon(Users),
      href: "/agents",
      permission: PERMISSIONS.USERS.READ,
      section: "Zespół",
    },
    {
      id: "contests",
      kind: "link",
      label: "Konkursy",
      icon: icon(Trophy),
      href: "/contests",
      permission: PERMISSIONS.CONTESTS.READ,
      section: "Zespół",
    },
    {
      id: "handbook",
      kind: "link",
      label: "Podręcznik Agenta",
      icon: icon(BookOpen),
      href: "/handbook",
      permission: PERMISSIONS.TOOLKIT.READ,
      section: "Zespół",
    },
    {
      id: "tenders",
      kind: "link",
      label: "Przetargi · test",
      icon: icon(Car),
      href: "/tenders",
      adminOnly: true,
      section: "Rozwój sprzedaży",
    },
    {
      id: "roles",
      kind: "link",
      label: "Role",
      icon: icon(Shield),
      href: "/roles",
      permission: PERMISSIONS.ROLES.READ,
      section: "Administracja",
    },
    {
      id: "commissions",
      kind: "link",
      label: "Konfiguracja prowizji",
      icon: icon(Percent),
      href: "/commissions",
      permission: PERMISSIONS.SETTLEMENTS.UPDATE,
      section: "Administracja",
    },
    {
      id: "audit",
      kind: "link",
      label: "Dziennik zmian",
      icon: icon(ScrollText),
      href: "/audit",
      permission: PERMISSIONS.AUDIT.READ,
      section: "Administracja",
    },
  ],
  secondary: [
    {
      id: "settings",
      kind: "link",
      label: "Ustawienia",
      icon: icon(Settings),
      href: "/settings",
    },
  ],
};
